import { render, staticRenderFns } from "./panelFilter.vue?vue&type=template&id=5081ceb0&scoped=true&"
import script from "./panelFilter.vue?vue&type=script&lang=js&"
export * from "./panelFilter.vue?vue&type=script&lang=js&"
import style0 from "./panelFilter.vue?vue&type=style&index=0&id=5081ceb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5081ceb0",
  null
  
)

export default component.exports